import api from './apiClient';

/**
 * Initiates Google OAuth flow for captions app
 * @returns {Promise<string>} - Google OAuth URL to redirect to
 */
export const initiateGoogleAuth = async () => {
    try {
        const response = await api.get('/api/auth/google/captions');
        return response.data.authUrl;
    } catch (error) {
        console.error('Error initiating Google auth:', error);
        throw error;
    }
};

export default initiateGoogleAuth;
